import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "34",
  height: "22",
  viewBox: "0 0 34 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M21.5053 2.78648H12.3635V19.2145H21.5053V2.78648Z",
      fill: "#FF5F00"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.944 11.0005C12.9426 9.41836 13.3011 7.85662 13.9924 6.43353C14.6838 5.01043 15.6899 3.76327 16.9345 2.78647C15.3932 1.575 13.5422 0.821613 11.593 0.612404C9.6438 0.403196 7.67507 0.746605 5.91182 1.6034C4.14858 2.46019 2.66196 3.79579 1.62189 5.45753C0.581821 7.11927 0.0302734 9.04011 0.0302734 11.0005C0.0302734 12.9609 0.581821 14.8817 1.62189 16.5435C2.66196 18.2052 4.14858 19.5408 5.91182 20.3976C7.67507 21.2544 9.6438 21.5978 11.593 21.3886C13.5422 21.1794 15.3932 20.426 16.9345 19.2145C15.6899 18.2377 14.6838 16.9906 13.9925 15.5675C13.3011 14.1444 12.9426 12.5826 12.944 11.0005Z",
      fill: "#EB001B"
    }, null, -1),
    _createElementVNode("path", {
      d: "M33.8381 11.0005C33.8382 12.9609 33.2867 14.8817 32.2467 16.5434C31.2067 18.2052 29.7201 19.5408 27.9569 20.3976C26.1937 21.2544 24.225 21.5978 22.2758 21.3886C20.3266 21.1794 18.4757 20.426 16.9345 19.2145C18.178 18.2367 19.1832 16.9894 19.8745 15.5665C20.5657 14.1436 20.9249 12.5824 20.9249 11.0005C20.9249 9.4186 20.5657 7.85736 19.8745 6.43449C19.1832 5.01162 18.178 3.76426 16.9345 2.78647C18.4757 1.575 20.3266 0.821608 22.2758 0.612402C24.225 0.403196 26.1937 0.74662 27.9569 1.60342C29.7201 2.46022 31.2067 3.79582 32.2467 5.45756C33.2867 7.1193 33.8382 9.04013 33.8381 11.0005Z",
      fill: "#F79E1B"
    }, null, -1),
    _createElementVNode("path", {
      d: "M32.8413 17.4745V17.1382H32.977V17.0697H32.6316V17.1382H32.7672V17.4745H32.8413ZM33.5119 17.4745V17.069H33.406L33.2842 17.3479L33.1624 17.069H33.0565V17.4745H33.1313V17.1687L33.2455 17.4324H33.323L33.4372 17.168V17.4745H33.5119Z",
      fill: "#F79E1B"
    }, null, -1)
  ])))
}
export default { render: render }